import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export enum CONFIG_CONTEXT {
  KITCHEN = 'kitchen',
  STORAGE = 'storage',
  BATHROOM = 'bathroom',
  CLOSET_DOORS = 'closetDoors',
  CLOSET_DOORS_STANDARD = 'closetDoorsStandard',
  CLOSET_DOORS_CUSTOM = 'closetDoorsCustom',
  FENCE = 'fence',
  DECKING_BOARDS = 'deckingBoards',
  WORKBENCH = 'workbench',
  CARPENTRY = 'carpentry',
  POSE = 'pose',
  BASKET = 'basket',
  BATHROOM_V2 = 'bathroomV2',
  CASTOMETRE = 'castometre',
  CASTOFID_MINI = 'castofidMini',
}

@Pipe({
  name: 'contextName',
  pure: true,
})
@Injectable({ providedIn: 'root' })
export class ContextNamePipe implements PipeTransform {
  constructor(public translate: TranslateService) { }

  transform(value: CONFIG_CONTEXT): string {
    const contextNames = {
      [CONFIG_CONTEXT.KITCHEN]: this.translate.instant('homepage.kitchen.title'),
      [CONFIG_CONTEXT.STORAGE]: this.translate.instant('homepage.storage.title'),
      [CONFIG_CONTEXT.BATHROOM]: this.translate.instant('homepage.bathroom.title'),
      [CONFIG_CONTEXT.CLOSET_DOORS]: this.translate.instant('homepage.closet.title'),
      [CONFIG_CONTEXT.CLOSET_DOORS_STANDARD]: this.translate.instant('homepage.closetDoorsStandard.title'),
      [CONFIG_CONTEXT.CLOSET_DOORS_CUSTOM]: this.translate.instant('homepage.closetDoorsCustom.title'),
      [CONFIG_CONTEXT.FENCE]: this.translate.instant('homepage.fence.title'),
      [CONFIG_CONTEXT.DECKING_BOARDS]: this.translate.instant('homepage.deckingBoards.title'),
      [CONFIG_CONTEXT.WORKBENCH]: this.translate.instant('homepage.workbench.title'),
      [CONFIG_CONTEXT.CARPENTRY]: this.translate.instant('homepage.carpentry.title'),
      [CONFIG_CONTEXT.POSE]: this.translate.instant('homepage.pose.title'),
      [CONFIG_CONTEXT.BATHROOM_V2]: this.translate.instant('homepage.bathroomV2.title'),
      [CONFIG_CONTEXT.BASKET]: this.translate.instant('homepage.basket.title'),
      [CONFIG_CONTEXT.CASTOMETRE]: 'Castomètre',
      [CONFIG_CONTEXT.CASTOFID_MINI]: 'Castofid Mini',
    };

    return contextNames[value] || 'Inconnu'; // Retourne un texte par défaut si la clé n'est pas trouvée
  }
}
